import { render, staticRenderFns } from "./LargeScreenV3.vue?vue&type=template&id=3b6e9a1a"
import script from "./LargeScreenV3.vue?vue&type=script&lang=js"
export * from "./LargeScreenV3.vue?vue&type=script&lang=js"
import style0 from "./LargeScreenV3.vue?vue&type=style&index=0&id=3b6e9a1a&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports